/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import {createRef, PureComponent, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import './StoreLocator.style';
import media, { WYSIWYG_MEDIA} from "Util/Media/Media";
import { STORE_LOCATOR_MEDIA_STORE } from "../../utils/media/index";
import Loader from 'Component/Loader/Loader.component';
import Link from "Component/Link";
import CmsBlock from 'Component/CmsBlock';
import pinBigImage from "../../public/assets/images/global/pin.svg";
import {MARKER_ICON_PATH, SELECTED_MARKER_ICON_PATH} from "../../component/GoogleMap/GoogleMap.component";
import matchSearchString from "../../utils/String/Helper";

export const GoogleMap = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "store-map" */
    '../../component/GoogleMap'
));
export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

export default class StoreLocator extends PureComponent {
    static propTypes = {
        storeLocatorData: PropTypes.object,
        google_map_api_key: PropTypes.string
    };

    static defaultProps = {
        storeLocatorData: {},
        selectedFilter: 0
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedCategories: [],
            selectedFilter: 0,
            selectedStore: null,
            previousSelectedStore: null,
            selectedStoreRenderIndex: null,
            mapSliderOpen:true,
            searchTerm : '',
            markerRef : {},
            filteredStores: [],
            regionFilterOpen: false
        }
        this.checkBoxChanged = this.checkBoxChanged.bind(this);
        this.flyTo = this.flyTo.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { selectedFilter, filteredStores } = this.state;
        const { storeLocatorData: { items } } = this.props;
        const { storeLocatorData: { items: prevItems } } = prevProps;
        if ((selectedFilter === 0 && filteredStores.length === 0 && items && items.length) || JSON.stringify(items) !== JSON.stringify(prevItems)) {
            let allStores = [];
            Object.entries(items).map(([key, {stores}]) => {
                if (stores.length !== 0) {
                    Object.entries(stores).map(([key, store]) => {
                        allStores.push(store);
                    })
                }
            });
            this.setState({
                filteredStores: allStores
            })
        }
    }

    imageRef = createRef();

    renderHeading() {
        const { blocks } = this.props;
        const topIdentifier = 'storelocator_top_block';
        if(!blocks[topIdentifier]) {
            return;
        }

        return <CmsBlock isHeader cmsBlock= { blocks[topIdentifier] } />;
    }


    renderBottomCotent() {
        const { blocks } = this.props;
        const bottomIdentifier = 'storelocator_bottom_block';

        if(!blocks[bottomIdentifier]) {
            return;
        }

        return <CmsBlock isHeader cmsBlock= { blocks[bottomIdentifier] } />;
    }

    addMarkerRef(storeId,marker){
        let { markerRef} = this.state
        markerRef[storeId] = marker;
        this.setState({markerRef : markerRef });
    }

    renderCheckboxes() {
        const {storeLocatorData: {items}} = this.props;
        if (items !== undefined && Object.keys(items).length !== 0) {
            return Object.entries(items).map(([key, {name, category_id, stores}]) => {
                return (<label key={key} className="list-checkbox">
                    <input className="list-checkbox__input"
                           name="stores"
                           type="checkbox"
                           value={category_id}
                           onChange={this.checkBoxChanged}
                    />
                    <span className="list-checkbox__box">
                       <span className="list-checkbox__tick">
                       </span>
                        <p className="list-checkbox__text">{name + ` (${stores.length})`}</p>
                   </span>
                </label>);
            });
        }
    }

    checkBoxChanged(checkbox) {
        const {storeLocatorData: {items}} = this.props;
        let selectedCategories = this.state.selectedCategories;
        selectedCategories = new Set(selectedCategories);
        let _checkbox = checkbox.target;
        if (_checkbox.checked)
            selectedCategories.add(_checkbox.value)
        else
            selectedCategories.delete(_checkbox.value)
        let filteredStores = [];
        Object.entries(items).map(([key, {category_id, stores}]) => {
            if (selectedCategories.has(category_id.toString()) || selectedCategories.size === 0) {
                Object.entries(stores).map(([key, store]) => {
                    if (/*store.region === this.state.selectedFilter || */selectedCategories.size === 0 || this.state.selectedFilter === 0) {
                        filteredStores.push(store);
                    }
                });
            }
        })
        filteredStores = filteredStores.filter(x => x !== undefined)
        selectedCategories = Array.from(selectedCategories);
        this.setState({
            selectedCategories: selectedCategories,
            filteredStores: filteredStores,
            selectedStoreRenderIndex : null,
            selectedStore : null
        });
    }

    regionFilterChanged(select) {
        let selectedFilter = select.target.value;
        const {storeLocatorData: {items}} = this.props;
        let selectedCategories = new Set(this.state.selectedCategories);
        if (select.target.value === "")
            selectedFilter = 0;
        let filteredStores = [];
        Object.entries(items).map(([key, {category_id, stores}]) => {
            if (selectedCategories.has(category_id.toString()) || selectedCategories.size === 0) {
                Object.entries(stores).map(([key, store]) => {
                    if (store.region === selectedFilter || selectedCategories.size === 0 || selectedFilter === 0) {
                        filteredStores.push(store);
                    }
                });
            }
        })
        this.setState({
            selectedFilter: selectedFilter,
            filteredStores: filteredStores,
            selectedStoreRenderIndex : null,
            selectedStore : null
        })
    }

    renderRegionFilter() {
        const {storeLocatorData: {regions}} = this.props;
        return (
            <>
                {
                    this.state.selectedCategories.length ?
                        <select className="select js-store-select choices__input" name="regions" id="store_regions"
                                onChange={this.regionFilterChanged.bind(this)}>
                            {
                                regions ?
                                    Object.entries(regions).map(([key, {name, id}]) => {
                                        if (key === "0")
                                            return (<option key={key} value={id}>Eπιλέξτε περιοχή</option>)
                                        else
                                            return (<option key={key} value={id}>{name}</option>)
                                    }) :
                                    null
                            }
                        </select>
                        :
                        ''
                }
            </>
        );
    }

    selectStore(store){
        const { map_markericon, map_selected_markericon } = this.props;
        const { markerRef } = this.state;
        let icon = map_markericon ? media(map_markericon,MARKER_ICON_PATH) : pinBigImage;
        let selected_icon = map_selected_markericon ? media(map_selected_markericon,SELECTED_MARKER_ICON_PATH) : pinBigImage;
        if(markerRef[store.store_id]){
            if(window.mapSelectedMarker && markerRef[store.store_id].getIcon() === icon)
                window.mapSelectedMarker.setIcon(icon);
            markerRef[store.store_id].setIcon(selected_icon);
            window.mapSelectedMarker = markerRef[store.store_id];
        }
        this.setState({
            selectedStore : store,
            selectedStoreRenderIndex :  store.store_id
        })
    }

    flyTo(store) {
        let zoom = isNaN(parseInt(store.zoom)) || store.zoom === null ? 15 : store.zoom;
        this.selectStore(store);
        window.map.panTo(new google.maps.LatLng(store.lat, store.lng));
        window.map.setZoom(parseInt(zoom));
    }

    renderStores() {
        let {filteredStores : filteredData, searchTerm } = this.state;
        filteredData = filteredData.sort(
            (a, b) => a.name.localeCompare(b.name)
        );
        const filteredStores = filteredData.filter(item => {
            return ['address','name','postcode','city'].some(key => {
                    return item[key] && matchSearchString(searchTerm,item[key])
                }
            );
        });

        const {device} = this.props;
        return (
            <>
                <ol className="shop-list__list">
                    {
                        filteredStores.map((store, i) => {
                            let store_image = store.store_image ? media(store.store_image, STORE_LOCATOR_MEDIA_STORE) : media('attra_icons/shop_photo.jpg', WYSIWYG_MEDIA);
                            return (
                                <>
                                <li id={"shop-list__shop_" + i} key={store.store_id} className="shop-list__shop">
                                    <div className={ this.state.selectedStoreRenderIndex == store.store_id ? "shop-list__wrapper is-active" : "shop-list__wrapper" } onClick={this.flyTo.bind(this, store)}>
                                        <span className="shop-list__checkbox"></span>
                                        <div className="shop-list__title">{store.name}</div>
                                        <div className="shop-list__text">
                                            <p>{store.address}</p>
                                            { store.phone ?
                                                <p>{ __('Τηλέφωνο : %s', store.phone) }</p>
                                                :
                                                ""
                                            }
                                        </div>
                                    </div>
                                    <Link to={store.url_alias} className={ 'shop-list__link' }>
                                        {__("Δείτε περισσότερα")}
                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6 12.5L10 8.5L6 4.5" stroke="black" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </Link>
                                </li>
                                </>
                            );
                        })
                    }
                </ol>
            </>
        );
    }

    renderMap() {
        const {filteredStores} = this.state;
        const { map_markericon, map_selected_markericon } = this.props;
        return (
            <div className={ `stores__map-wrapper slider ${this.state.mapSliderOpen ? "is-active" : ""} ` }>
                <div className="stores__map-spacer">
                    <div className="stores__map-container">
                        {
                            this.state.selectedStore ?
                                <div className="store-tooltip stores__tooltip">
                                    <div className="store-tooltip__title">{ this.state.selectedStore.name }</div>
                                    <div className="store-tooltip__text">{ this.state.selectedStore.address }</div>
                                    <div className="store-tooltip__title">{ __('OPENING HOURS') }</div>
                                    <div className="store-tooltip__content" dangerouslySetInnerHTML={{__html: this.state.selectedStore.open_hours}} ></div>
                                    <a className="store-tooltip__link hide-lg"
                                       href={"https://www.google.com/maps/search/?api=1&z=14&query="+this.state.selectedStore.lat+","+this.state.selectedStore.lng} target="_blank">
                                        <span>{__("INSTRUCTIONS")}</span>
                                        <UniversalIcon
                                            src={media('attra_icons/arrow_button.png', WYSIWYG_MEDIA)}
                                             alt=""
                                            className="icon_close"
                                            id="icon_close"
                                        />
                                        {/*<svg*/}
                                        {/*    className="icon_close"*/}
                                        {/*    id="icon_close"*/}
                                        {/*>*/}
                                        {/*    <use xlinkHref={`${icon}#icon_arrow_button`}/>*/}
                                        {/*</svg>*/}
                                    </a>
                                </div>
                                :
                                ''
                        }
                    <Suspense fallback={ <Loader /> }>
                        {/*<LeafletMapComponent*/}
                        {/*    isVisible={this.state.selectedStoreRenderIndex !== null}*/}
                        {/*    isExpanded={this.state.mapSliderOpen}*/}
                        {/*    stores={filteredStores}*/}
                        {/*    selectStore={this.selectStore.bind(this)}*/}
                        {/*    prevSelectedStores={this.state.previousSelectedStore}*/}
                        {/*    selectedStore={this.state.selectedStore}*/}
                        {/*/>*/}
                        <GoogleMap
                            selectStore={this.selectStore.bind(this)}
                            addMarkerRef={this.addMarkerRef.bind(this)}
                            map_markericon={map_markericon}
                            map_selected_markericon={map_selected_markericon}
                            items={filteredStores}
                        />
                    </Suspense>
                        <div  className="stores__tooltip-close js-store-tooltip-close hide-lg">
                            <UniversalIcon
                                src={media('attra_icons/close.png', WYSIWYG_MEDIA)}
                                alt=""
                                className="icon_close"
                                id="icon_close"
                            />
                            {/*<svg*/}
                            {/*    className="icon_close"*/}
                            {/*    id="icon_close"*/}
                            {/*    viewBox="0 0 14 14"*/}
                            {/*>*/}
                            {/*    <use xlinkHref={`${icon}#icon_close`}/>*/}
                            {/*</svg>*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    handleSearchChange(event){
        this.setState({ searchTerm: event.target.value });
    }

    accessLocation(){
        let { map_zoom } = this.props;
        map_zoom = map_zoom ? map_zoom : 15;
        console.log(map_zoom)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                window.map.panTo(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                window.map.setZoom(14);
            });
        }
    }

    renderSearchSection(){
        const { searchTerm } = this.state;

        return(
            <>
                <input className='search_store' type='text' placeholder={__('Search by city, address or postal code')} value={ searchTerm } onChange={ this.handleSearchChange.bind(this) } />
                <button className='shop_nearby' onClick={this.accessLocation.bind(this)}>
                    { __('Καταστήματα κοντά') }
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="6.99996" cy="7" r="2.33333" fill="black"/>
                        <circle cx="7.00004" cy="7" r="5.16667" stroke="black"/>
                        <rect x="6.41663" y="0.583336" width="1.16667" height="1.16667" fill="black"/>
                        <rect x="12.25" y="6.41667" width="1.16667" height="1.16667" fill="black"/>
                        <rect x="6.41663" y="12.25" width="1.16667" height="1.16667" fill="black"/>
                        <rect x="0.583374" y="6.41667" width="1.16667" height="1.16667" fill="black"/>
                    </svg>

                </button>
            </>
        );
    }

    freezeScroll() {
        this.YoffsetWhenScrollDisabled = window.pageYOffset || document.body.scrollTop;
        document.documentElement.classList.add('scrollDisabled');
        document.body.style.marginTop = `${-this.YoffsetWhenScrollDisabled}px`;
    }

    unfreezeScroll() {
        document.documentElement.classList.remove('scrollDisabled');
        document.body.style.marginTop = 0;
        window.scrollTo(0, this.YoffsetWhenScrollDisabled);
    }

    openRegionFilter(){
        const { regionFilterOpen } = this.state;
        this.setState({ regionFilterOpen: true });
        this.freezeScroll();
    }

    closeRegionFilter(){
        const { regionFilterOpen } = this.state;
        this.setState({ regionFilterOpen: false });
        this.unfreezeScroll();
    }

    render() {
        const { regionFilterOpen } = this.state;

        return (
            <main
                block="StoreLocator stores"
            >
                <div block="StoreLocator" elem="Wrapper" className="ContentWrapper">
                    {this.renderHeading()}
                    <div block="StoreLocator" elem="Content">
                        <div className="stores__left">
                            <div className="stores__checkboxes_button Button" onClick={this.openRegionFilter.bind(this)}>{ __('Region Filter') }</div>
                            <div className={`stores__checkboxes ${regionFilterOpen ? 'active' : ''}`} >
                                {this.renderCheckboxes()}
                            </div>
                            <div className="stores__checkboxes_title">{ __('Region Filter') }</div>
                            <div className="stores__checkboxes_close" onClick={this.closeRegionFilter.bind(this)}>
                                <UniversalIcon
                                    src={media('close.svg', WYSIWYG_MEDIA)}
                                    alt="closeIcon"
                                    className="Image-Image"
                                />
                            </div>
                            <div className="stores__checkboxes_search Button" onClick={this.closeRegionFilter.bind(this)}>{ __('Apply Filter') }</div>
                            {/*<div className="stores__filter">*/}
                            {/*    {this.renderRegionFilter()}*/}
                            {/*</div>*/}
                            <div className="shop-search-controls">
                                {this.renderSearchSection()}
                            </div>
                            <div className="shop-list stores__list">
                                {this.renderStores()}
                                {this.renderMap() }
                            </div>
                        </div>
                    </div>
                    { this.renderBottomCotent() }
                </div>
            </main>
        );
    }
}
